import { State } from '../StateTypes';

/**
 * Select init state slice
 * @param state
 */
export const selectInit = (state: State) => state.init;

/**
 * Select init is loading
 * @param state
 */
export const selectInitLoading = (state: State) => selectInit(state).loading;

/**
 * Select init is done loading
 * @param state
 */
export const selectInitDone = (state: State) => !selectInitLoading(state);

/**
 * Select init failed
 * @param state
 */
export const selectInitFailed = (state: State) => selectInit(state).error;

/**
 * Export const select init successful
 * @param state
 */
export const selectInitSuccessful = (state: State) =>
  selectInitDone(state) && !selectInitFailed(state);
